import React, { useState } from "react";
import styled from "styled-components";

const Navbar = ({ onSignInClick, onSignUpClick }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Nav>
        <LeftSide>
          <Logo>EYE20 GROUP</Logo>
        </LeftSide>

        <RightSide>
          <AuthButtons>
            <button onClick={onSignInClick}>Sign In</button>
            <button onClick={onSignUpClick}>Sign Up</button>
          </AuthButtons>

          <Hamburger onClick={() => setIsOpen(!isOpen)}>☰</Hamburger>
        </RightSide>
      </Nav>

      {isOpen && (
        <Dropdown>
          <a href="#services" onClick={() => setIsOpen(false)}>Services</a>
          <a href="#testimonials" onClick={() => setIsOpen(false)}>Testimonials</a>
          <a href="#join" onClick={() => setIsOpen(false)}>Join</a>
        </Dropdown>
      )}
    </>
  );
};

const Nav = styled.nav`
  background: #003366;
  color: white;
  padding: 0.8rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 1000;
`;

const LeftSide = styled.div`
  display: flex;
  align-items: center;
`;

const Logo = styled.h1`
  font-size: 1.4rem;
  font-weight: bold;

  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
`;

const RightSide = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const Hamburger = styled.div`
  display: none;
  font-size: 1.8rem;
  cursor: pointer;

  @media (max-width: 768px) {
    display: block;
  }
`;

const AuthButtons = styled.div`
  display: flex;
  gap: 0.6rem;

  button {
    background-color: #e2725b;
    border: none;
    color: white;
    padding: 0.4rem 0.8rem;
    border-radius: 4px;
    font-weight: 600;
    font-size: 0.9rem;
    cursor: pointer;

    &:hover {
      background-color: #c55a45;
    }
  }

  @media (max-width: 768px) {
    gap: 0.4rem;

    button {
      font-size: 0.75rem;
      padding: 0.3rem 0.6rem;
    }
  }
`;

const Dropdown = styled.div`
  background-color: #003366;
  display: flex;
  flex-direction: column;
  padding: 1rem 1.5rem;
  gap: 1rem;
  position: absolute;
  top: 60px;
  width: 100%;
  z-index: 999;

  a {
    color: white;
    text-decoration: none;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export default Navbar;
